import { Component, EventEmitter, Output, Input, Renderer, SimpleChanges, SimpleChange } from '@angular/core';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { NgbTypeaheadSelectItemEvent, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Product, ProductAlias } from '../../api/models/product-alias';
import { ProductAliasService } from '../../api/services/product-alias.service';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import { ProductSetupRequestAddComponent } from './product-setup-request-add/product-setup-request-add.component';
import { AnalyticsService } from '../../api/services/analytics.service';

@Component({
  selector: 'app-product-alias',
  templateUrl: './product-alias.component.html',
  styleUrls: ['./product-alias.component.scss']
})
export class ProductAliasComponent {

  @Output() selected: EventEmitter<ProductAlias> = new EventEmitter<ProductAlias>();

  @Input()
  set showSelected(value) {
    this.hideSelected = value !== 'true';
  }

  @Input()
  set focusOnAdd(value) {
    this.setFocusOnAdd = value === 'true';
  }
  @Input() accountNumber;
  @Input() accountNumbers: string [];
  @Input() productSelected;
  @Input() orgId;
  productdata: string;

  searching: boolean = false;
  hideSelected = false;
  setFocusOnAdd = false;
  currentMarketId: string;

  constructor(
    private renderer: Renderer,
    private productAliasService: ProductAliasService,
    private modalService: NgbModal,
    private analyticsService: AnalyticsService
  ) { }

  productFormatter = (result: Product) => {

    return result.sku ? `${Product.toString(result)}` : 'CREATE_PRODUCT_SETUP_REQUEST';

  }

  productSearch = (text$: Observable<string>) =>
    text$
      .debounceTime(1000)
      .distinctUntilChanged()
      .do(()=>this.searching = true)
      .switchMap(term =>
        !term ? of([]) : this.searchProductDetails(term)
        .map(results => results.concat([new ProductAlias()]))
        .catch(() => {
          this.searching = false;
          return of([]);
        })
      )
      .do(()=>this.searching = false);


  private searchProductDetails(term: string) {
    const marketType = localStorage.getItem("marketType");
    if (typeof this.accountNumber != 'undefined' && this.accountNumber) {
      this.sendDataToAnalytics('worksheet', term);
      return this.productAliasService.searchV2(term, this.accountNumber);
    } else {
      this.sendDataToAnalytics('master_bom', term);
      return this.productAliasService.searchProductForMasterBom(term, this.orgId, this.accountNumbers);
    }
  }

  private sendDataToAnalytics(type: 'worksheet' | 'master_bom',term: string) {
    if(type=='worksheet'){
      this.analyticsService.trackProductSearchWorksheet(term);
    }else{
      this.analyticsService.trackProductSearchMasterBOM(term);

    }
  }

  onProductSelected($event: NgbTypeaheadSelectItemEvent, alias: HTMLInputElement) {
    if (!$event.item.sku) {
      $event.item.alias = alias.value;
      alias.value = null;
      $event.preventDefault();
      this.productSetupRequestModal();
    }
    if (this.hideSelected) {
      alias.value = null;
      $event.preventDefault();
    }
    if (this.setFocusOnAdd) {
      this.renderer.invokeElementMethod(alias, 'focus', []);
    }
    this.selected.emit($event.item);
  }

  private productSetupRequestModal() {
    const modalRef = this.modalService.open(ProductSetupRequestAddComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.result
      .then(() => { })
      .catch(() => { });
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.productSelected !== undefined && this.productSelected) {
      this.productdata = null;
    }

    let accountNumbers: SimpleChange = changes.accountNumbers;
    if(accountNumbers) {
      this.accountNumbers = accountNumbers.currentValue;
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/product-alias/product-alias.component.ts